import {Button, ButtonGroup} from "@client/components/Button";
import {ratingRequestClass} from "@client/components/styles";
import {RATING_ACTIONS} from "@client/features/scenes";
import {AnimatePresence, motion} from "motion/react";
import * as React from "react";

type Props = {
    isAskingForRating: "feeler" | "rating" | "feedback";
} & {[P in keyof RATING_ACTIONS]: () => void};

export const RatingRequest = (props: Props) => {
    let question;
    const style = "flex items-center px-4 pt-2 pb-4 text-base font-normal text-pretty";

    if (props.isAskingForRating === "feeler") {
        question = (
            <div className="contents" key={props.isAskingForRating}>
                <p className={style}>
                    Does Joy help you track your nutrition and workouts?
                </p>
                <ButtonGroup>
                    <Button onClick={props.answerFeelerPositively}>Yes it does!</Button>
                    <Button onClick={props.answerFeelerNegatively}>Not really</Button>
                </ButtonGroup>
            </div>
        );
    } else if (props.isAskingForRating === "rating") {
        question = (
            <div className="contents" key={props.isAskingForRating}>
                <p className={style}>Great! Please leave us a review.</p>
                {/* Buttons removed as per new flow */}
            </div>
        );
    } else {
        question = (
            <div className="contents" key={props.isAskingForRating}>
                <p className={style}>
                    Would you mind giving us some feedback? We take it seriously.
                </p>
                <ButtonGroup>
                    <Button onClick={props.agreeToProvideFeedBack}>Sure!</Button>
                    <Button onClick={props.declineToProvideFeedBack}>No, thanks</Button>
                </ButtonGroup>
            </div>
        );
    }

    return (
        <motion.div className={ratingRequestClass} exit={{opacity: 0, height: 0}}>
            <AnimatePresence mode="wait">
                <motion.div
                    key={props.isAskingForRating}
                    className="flex min-h-32 flex-col items-center"
                    initial={{opacity: 0, x: 20}}
                    animate={{opacity: 1, x: 0}}
                    exit={{opacity: 0, x: -20}}
                    transition={{duration: 0.2}}
                >
                    {question}
                </motion.div>
            </AnimatePresence>
        </motion.div>
    );
};
